import { ArrowLeftIcon, CaretLeftIcon } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import { TextButton } from '@/components/common/text-button';

export type BackButtonProps = {
  /** Default 'Back'. */
  label?: string;
  /** Default: navigate(-1). */
  onClick?: () => void;
  /**
   * The 12px caret + 13px label the design uses where Back shares a line with other controls
   * (Figma 745:627454 — the Renew Subscriptions header). The default 24px arrow + 16px label is
   * the standalone treatment every other screen draws.
   */
  compact?: boolean;
  className?: string;
};

export function BackButton({
  label = 'Back',
  onClick,
  compact = false,
  className,
}: BackButtonProps) {
  const navigate = useNavigate();
  return (
    <TextButton
      className={className}
      size={compact ? 'sm' : 'md'}
      startIcon={compact ? <CaretLeftIcon size={12} /> : <ArrowLeftIcon size={24} />}
      onClick={onClick ?? (() => navigate(-1))}
    >
      {label}
    </TextButton>
  );
}
